import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, Button, Clearfix } from 'react-bootstrap';

import EntityStateUpdater from 'component/EntityStateUpdater';

import { changeUploadContext, resetUploadContext, fileUploadHelper } from 'actions/UploadActions';
import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';

import RoundImage from 'components/layout/RoundImage';
import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';

import ClientCarData from 'components/layout/item/ClientCarData';
import ClientCarServices from 'components/layout/item/ClientCarServices';

import Entity from 'components/Entity';
import Data from 'components/Data';

import { entityMetaMapping } from 'js/constants';

import FormErrors from 'components/forms/FormErrors';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class ClientCarDetails extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entityLoaded: false,
      entityChanged: false,
    };

    this.entity = new Entity();

    if (props.meta[entityMetaMapping.clientCar] !== undefined && !props.meta[entityMetaMapping.clientCar].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.clientCar);
    }

    this.uploadInput = React.createRef();
  }

  componentWillMount = () => {
    const {
      match: {
        params: { clientCarId },
      },
      updateUploadContext,
    } = this.props;

    updateUploadContext({
      type: 'item_img',
      itemId: clientCarId,
      uploadLink: '/api/clientcars/' + clientCarId + '/assets.json',
    });
  };

  componentWillUnmount = () => {
    this.props.doResetUploadContext();
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      meta,
      data,
      formStatus,
      doNotify,
    } = this.props;
    const { entityLoaded } = this.state;

    // car data was saved and there was no error
    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState({ entityChanged: false });
      doNotify(1, messages.page_saved);
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData(data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (
      meta[entityMetaMapping.clientCar] !== undefined &&
      !meta[entityMetaMapping.clientCar].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.clientCar);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    // check if the car image was uploaded
    if (entityLoaded && !data.pending && !prevProps.data.pending) {
      const prevPropsDefaultImgId =
        prevProps.data.data.item &&
        prevProps.data.data.item.default_img &&
        prevProps.data.data.item.default_img.id &&
        prevProps.data.data.item.default_img.variations
          ? prevProps.data.data.item.default_img.id
          : null;
      const defaultImgId =
        data.data.item && data.data.item.default_img && data.data.item.default_img.id
          ? data.data.item.default_img.id
          : null;
      if (defaultImgId && (defaultImgId !== prevPropsDefaultImgId || !prevPropsDefaultImgId)) {
        // we have a new image
        // update the entity (quiet)
        const value = this.state.entity.createValue('defaultImg', ['item'], data.data.item.default_img);
        this.updateEntity('defaultImg', value, ['item'], null, false);

        this.props.doNotify(1, this.props.intl.messages.file_uploaded);
      }
    }
  };

  formSubmit = e => {
    e.preventDefault();

    this.changeEntity(this.state.entity.validate(), () => {
      if (this.state.entity.isValid) {
        this.props.onSubmit(this.props.match.params.clientCarId, this.state.entity.processedData);
      }
    });
  };

  getTabHeaderList = () => {
    const {
      intl: { messages },
    } = this.props;
    const result = [];

    result.push(messages.car);
    result.push(messages.car_service_appointments);

    return result;
  };

  getTabContentList = () => {
    const { formStatus } = this.props;
    const { entity, entityLoaded } = this.state;
    const result = [];

    result.push(
      <ClientCarData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={this.changeEntity}
        disabled={formStatus.pending}
        key="clientCarData"
      />
    );

    result.push(
      <ClientCarServices
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={this.changeEntity}
        disabled={formStatus.pending}
        key="clientCarServiceOrders"
      />
    );

    return result;
  };

  getTabKeepMounted = () => {
    const keepMounted = [];
    return keepMounted;
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;
    const { entityLoaded, entity } = this.state;

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/myCars', name: messages.cars },
          { link: null, name: entityLoaded ? entity.getName() : null },
        ]}
        className="p-t-0"
      />
    );
  };

  manualUpload = files => {
    const {
      uploadFile,
      upload: {
        context: { uploadLink, data: uploadContextData },
      },
    } = this.props;
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      uploadFile(file, uploadLink, uploadContextData);
    }
  };

  render() {
    const {
      intl: { messages },
      match,
      data,
      formStatus,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    let metaTitle = messages.page;
    if (entityLoaded) {
      metaTitle += ' - ' + entity.getName();
    }

    return (
      <DocMeta tags={generateMetaTags(messages.meta.page_details, metaTitle)}>
        <div class="padding-25 sm-padding-10">
          <Data dataName="clientCar" url={'/api/clientcars/' + match.params.clientCarId + '.json'} data={data} />
          <FormErrors formStatus={formStatus} />

          <form method="put" onSubmit={this.formSubmit} key={entityLoaded ? entity.getId() : 1}>
            {this.getBreadcrumb()}

            <section class="panel no-padding">
              <div class="client-profile-header">
                <Row>
                  <Col xs={12} sm={8}>
                    <div class="text-center p-t-10 p-b-10 pull-left" style={{ width: '260px' }}>
                      {entityLoaded && getThumbFileFromEntity(entity.getItem().getDefaultImg()) ? (
                        <img
                          src={getThumbFileFromEntity(entity.getItem().getDefaultImg()).getWebLink()}
                          className="full-width"
                          alt={entity.getName()}
                        />
                      ) : (
                        <RoundImage size={75}>
                          <div class="relative">
                            <span class="fa-stack fa-2x" style={{ fontSize: '85px' }}>
                              <i class="fal fa-circle fa-stack-2x" />
                              <i class="fad fa-car fa-stack-1x" />
                            </span>

                            {entityLoaded ? (
                              <div class="pull--40">
                                <input
                                  type="file"
                                  ref={this.uploadInput}
                                  style={{ display: 'none' }}
                                  onChange={e => this.manualUpload(e.target.files)}
                                />
                                <Button bsSize="sm" class="btn-rounded" onClick={e => this.uploadInput.current.click()}>
                                  <i class="fa fa-upload m-r-10" /> {messages.upload}
                                </Button>
                              </div>
                            ) : null}
                          </div>
                        </RoundImage>
                      )}
                    </div>
                    {entityLoaded && (
                      <div class="pull-left m-l-10">
                        <h5 class="m-t-40 text-uppercase">{entity.getName()}</h5>
                        <h3 class="m-t-20">
                          {entity.getBrandName()} {entity.getModelName()}
                        </h3>
                      </div>
                    )}
                    <Clearfix />
                  </Col>
                </Row>
              </div>
            </section>

            <Row>
              <Col xs={12}>
                <div class="text-right m-b-10">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    type="submit"
                    bsStyle={this.state.entityChanged ? 'primary' : 'default'}
                  >
                    <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {messages.save}
                  </Button>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Tabs
                  tabs={this.getTabHeaderList()}
                  tabContent={this.getTabContentList()}
                  keepMounted={this.getTabKeepMounted()}
                />
              </Col>
            </Row>
          </form>
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.clientCar,
    formStatus: state.formStatus.clientCarEdit,
    meta: state.entityMeta,
    user: state.login.user,
    upload: state.upload,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (clientCarId, args) => {
      formStatusDispatchHelper('clientCarEdit', '/api/clientcars/' + clientCarId + '.json', args, 'put', dispatch);
    },
    uploadFile: fileUploadHelper(dispatch),
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientCarDetails)
);
